import { useState } from "react";
import { Box, CircularProgress, FormControl, MenuItem, Select, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import ConfirmationDialog from "../../../Components/ConfirmationDialog/ConfirmationDialog";
import { useGetCancelReasons } from "../hooks/use-get-cancel-reasons";

const CancelReasonDialog = ({ open, onClose, classes, updatePatientActions, dialogData }) => {
  const { t } = useTranslation();
  const [cancelReason, setCancelReason] = useState("");
  const { data: cancelReasonOptions = [], isLoading: cancelReasonsLoading } = useGetCancelReasons(open);

  const handleClose = () => {
    setCancelReason("");
    onClose();
  };

  const handleConfirm = async () => {
    await updatePatientActions(
      dialogData?.value,
      dialogData?.userId,
      dialogData?.scanId,
      true,
      dialogData?.iprId,
      dialogData?.scn,
      cancelReason,
    );
    handleClose();
  };

  return (
    <ConfirmationDialog
      open={open}
      handleConfirm={handleConfirm}
      dialogTitle={t("cancel-reason-dialog-title")}
      confirmationButtonText={t("Save-cancel-appointment")}
      cancelButtonText={"Close"}
      isWarning={true}
      enableDialog={Boolean(cancelReason) && !cancelReasonsLoading}
      cancelFirst={true}
      actionsStyle={{
        justifyContent: "space-between",
        width: "100%",
        paddingLeft: 24,
        paddingRight: 24,
        paddingBottom: 12,
      }}
      handleClose={handleClose}
      handleOutsideClick={handleClose}
      confirmBtnStyle={{ width: "fit-content" }}
    >
      {cancelReasonsLoading ? (
        <Box className={classes.loadingBox}>
          <CircularProgress className={classes.loading} />
        </Box>
      ) : (
        <Box style={{ paddingLeft: 8, paddingRight: 8, paddingBottom: 8 }}>
          <Typography
            variant="body2"
            color="textSecondary"
            style={{ marginBottom: 12 }}
          >
            {t("cancel-reason-select-placeholder")}
          </Typography>
          <FormControl style={{ width: "100%" }}>
            <Select
              variant="outlined"
              fullWidth
              value={cancelReason}
              onChange={(e) => setCancelReason(e.target.value)}
              displayEmpty
              renderValue={(selected) => {
                if (!selected)
                  return (
                    <span style={{ color: "#9e9e9e" }}>
                      {t("cancel-reason-dialog-default")}
                    </span>
                  );
                const option = cancelReasonOptions.find(opt => opt.value === selected);
                return option ? option.label : selected;
              }}
              MenuProps={{
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left",
                },
                transformOrigin: {
                  vertical: "top",
                  horizontal: "left",
                },
                getContentAnchorEl: null,
                PaperProps: {
                  style: {
                    marginTop: 4,
                  },
                },
              }}
            >
              <MenuItem value={""} disabled style={{ display: "none" }}>
                {t("cancel-reason-dialog-default")}
              </MenuItem>
              {cancelReasonOptions.map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>
                  {opt.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      )}
    </ConfirmationDialog>
  );
};

export default CancelReasonDialog;
